import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '../button/Button.jsx';
import s from './CommandLineTools.module.scss';

/*
 * Button that replaces a standard "file upload" button with something "nicer"
 * When the button is clicked the OS file selection dialog pops up; when files are selected onFileSelected is called
 * with an array of the files that were picked
 */
class UploadFileButton extends Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
        multiple: PropTypes.bool.isRequired,
        onFileSelected: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.onClick = () => this.fileInputButton.click();
    }

    render = () => (
        <div>
            <Button id={`${this.props.label}-button`} label={this.props.label} onClick={this.onClick} />
            <input id={this.props.label} multiple={this.props.multiple} style={{ display: 'none' }} type="file" ref={i => (this.fileInputButton = i)} onInput={this.props.onFileSelected} />
        </div>
    );
}

// ---------------------------------------------------------------------------------------------------------------------
// One-off component to display "Reset badges and logos to defaults"
const FixBadgesAndLogos = props => (
    <div>
        <div>Reset badges and logos to defaults within an AI JSON file</div>
        <ul>
            <li>Upload a v5.json (aka AI JSON) file</li>
            <li>
                All badges have their scaling set to the <strong>Badge Scale</strong> value below (default is 0.17)
            </li>
            <li>All badges have their rotation set to 0</li>
            <li>The logos will be updated to all lower-case names without spaces</li>
        </ul>

        <div style={{ margin: '10px 0' }}>Any validation errors will be listed in the browser console log</div>

        <label style={{ marginBottom: 10 }} htmlFor="badge-scale">
            <span style={{ marginRight: 10 }}>Badge Scale</span>
            <input style={{ marginBottom: 10, width: 50, padding: 10 }} name="badge-scale" id="badge-scale" placeholder="0.17" defaultValue={0.17} />
        </label>

        <UploadFileButton multiple={false} label="Reset badges and logos" onFileSelected={event => props.onFixBadgesAndLogos(event, document.getElementById('badge-scale').value)} />
    </div>
);
FixBadgesAndLogos.propTypes = { onFixBadgesAndLogos: PropTypes.func.isRequired };

// ---------------------------------------------------------------------------------------------------------------------
// One-off component to display "pixify svg's"
const PixifySvgs = props => (
    <div>
        <div>Pixify SVG's</div>
        <ul>
            <li>Upload one or more SVG files</li>
            <li>Each SVG will be aggressively simplified to match the capabilities of our PIXI implementation</li>
            <li>The downloaded result will be a zip file with SVG files that have been "pixified"</li>
        </ul>

        <div style={{ margin: '10px 0' }}>Any validation errors will be listed in the browser console log</div>

        <div>
            <UploadFileButton multiple label="Pixify SVG's" onFileSelected={props.onPixifySvg} />
        </div>
    </div>
);
PixifySvgs.propTypes = { onPixifySvg: PropTypes.func.isRequired };

// ---------------------------------------------------------------------------------------------------------------------
// One-off component to display "Pretty-print AI JSON"
const PrettyPrintAiJson = props => (
    <div>
        <div>Pretty-print AI JSON</div>
        <ul>
            <li>Upload a v5.json (aka AI JSON) file</li>
            <li>The downloaded result will be reformatted to make it easier to read by adding spaces</li>
        </ul>

        <div style={{ margin: '10px 0' }}>Any validation errors will be listed in the browser console log</div>

        <div>
            <UploadFileButton multiple={false} label="Pretty-print AI JSON" onFileSelected={props.onPrettyPrintAiJson} />
        </div>
    </div>
);
PrettyPrintAiJson.propTypes = { onPrettyPrintAiJson: PropTypes.func.isRequired };

// ---------------------------------------------------------------------------------------------------------------------

const V6ifyAiJson = props => (
    <div>
        <div>Convert a v5 AiJson into a v6 AiJson with uuids</div>
        <ul>
            <li>Upload a v5.json (aka AI JSON) file</li>
            <li>Input the venue id (ex: atl, phl)</li>
            <li>All features will get uuids</li>
        </ul>

        <div style={{ margin: '10px 0' }}>Any errors will be listed in the browser console log</div>

        <label style={{ marginBottom: 10 }} htmlFor="v6-venueId">
            <span style={{ marginRight: 10 }}>Venue Id</span>
            <input style={{ marginBottom: 10, width: 60, padding: 10 }} name="v6-venueId" id="v6-venueId" placeholder="atl" defaultValue="atl" />
        </label>

        <UploadFileButton multiple={false} label="V6ify AiJson" onFileSelected={event => props.onV6ifyAiJson(event, document.getElementById('v6-venueId').value)} />
    </div>
);
V6ifyAiJson.propTypes = { onV6ifyAiJson: PropTypes.func.isRequired };

// ---------------------------------------------------------------------------------------------------------------------
/*
 * Display all the command-line tools that can be run from this page.
 */
const CommandLineTools = props => (
    <div className={s.commandLineTools}>
        <hr />
        <V6ifyAiJson onV6ifyAiJson={props.onV6ifyAiJson} />
        <hr />
        <FixBadgesAndLogos onFixBadgesAndLogos={props.onFixBadgesAndLogos} />
        <hr />
        <PixifySvgs onPixifySvg={props.onPixifySvgs} />
        <hr />
        <PrettyPrintAiJson onPrettyPrintAiJson={props.onPrettyPrintAiJson} />
        <hr />
    </div>
);

CommandLineTools.propTypes = {
    onFixBadgesAndLogos: PropTypes.func.isRequired,
    onPixifySvgs: PropTypes.func.isRequired,
    onPrettyPrintAiJson: PropTypes.func.isRequired,
    onV6ifyAiJson: PropTypes.func.isRequired,
};

export default CommandLineTools;
